import React from 'react';
import PropTypes from 'prop-types';
import {utils, writeFile} from 'xlsx';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData, formatDate, ExcelDateToDateString} from "../../globals/GlobalFunctions";
import {GlobalConstants} from "../../globals/GlobalConstants";

export interface Props {
    excelData: any;
}

//maps for assigning dependant addresses
let addressMap = new Map<string, string>();

let address2Map = new Map<string, string>();

let cityMap = new Map<string, string>();

let stateMap = new Map<string, string>();

let zipMap = new Map<string, string>();

//fixed width format
function FairscriptsFormatter ({excelData}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    try{
        //Check for 2 sheets here
        if (!isEmpty(excelData) && excelData.Sheets.FS !== undefined) {
            let eligSheetDataArray = extractWorkSheetData(excelData.Sheets.FS);

            let eligRawCellArray: any[] = eligSheetDataArray[0];

            let eligColumnRange: number = eligSheetDataArray[1];

            let eligRowRange: number = eligSheetDataArray[2];

            const eligValuesIndexCollection = {
                memberSegIndex: eligRawCellArray.indexOf('Member Sequence') + 1,
                altIDIndex: eligRawCellArray.indexOf('Member Alternate ID') + 1,
                fnIndex: eligRawCellArray.indexOf('Member First Name') + 1,
                lnIndex: eligRawCellArray.indexOf('Member Last Name') + 1,
                dobIndex: eligRawCellArray.indexOf('Member Date of Birth') + 1,
                subscriberIndex: eligRawCellArray.indexOf('Subscriber ID') + 1,
                enrollDateIndex: eligRawCellArray.indexOf('Effective Date') + 1,
                sexIndex: eligRawCellArray.indexOf('Member Gender') + 1,
                groupIndex: eligRawCellArray.indexOf('Group ID') + 1,
                subscriberSSNIndex: eligRawCellArray.indexOf('Subscriber SSN') + 1,
                mnIndex: eligRawCellArray.indexOf('Member Middle Name') + 1,
                addIndex: eligRawCellArray.indexOf('Member Address') + 1,
                add2Index: eligRawCellArray.indexOf('Member Address 2') + 1,
                cityIndex: eligRawCellArray.indexOf('Member City') + 1,
                stateIndex: eligRawCellArray.indexOf('Member State') + 1,
                zipIndex: eligRawCellArray.indexOf('Member Zip Code') + 1,
                phoneIndex: eligRawCellArray.indexOf('Member Home Phone') + 1,
                emailIndex: eligRawCellArray.indexOf('Member Email Address') + 1,
                disenrollDateIndex: eligRawCellArray.indexOf('Termination Date') + 1,
                divisionIndex: eligRawCellArray.indexOf('Division ID') + 1,
                planTypeIndex: eligRawCellArray.indexOf('Plan Type') + 1,
                planIDIndex: eligRawCellArray.indexOf('Plan ID') + 1,
            }

            //set sub address for dependant records
            for (let i = 1; i < eligRowRange; i++) {
                let rowMultiplier = eligColumnRange * i - 1;

                if(eligValuesIndexCollection.subscriberSSNIndex > 0 && eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.memberSegIndex)].toString() === "01"){
                    if(eligValuesIndexCollection.addIndex > 0) {
                        addressMap.set(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString(), eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.addIndex)].toString())
                    }
                    if(eligValuesIndexCollection.add2Index > 0) {
                        address2Map.set(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString(), eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.add2Index)].toString())
                    }
                    if(eligValuesIndexCollection.cityIndex > 0) {
                        cityMap.set(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString(), eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.cityIndex)].toString())
                    }
                    if(eligValuesIndexCollection.stateIndex > 0) {
                        stateMap.set(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString(), eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.stateIndex)].toString())
                    }
                    if(eligValuesIndexCollection.zipIndex > 0) {
                        zipMap.set(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString(), eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.zipIndex)].toString())
                    }
                }
            }

            let arrayOfMemberArrays: any[] = [];

            for (let i = 1; i < eligRowRange; ++i) {
                let memberArray : any[] = [];

                let memberString = "";

                let rowMultiplier = eligColumnRange * i - 1;

                let today = new Date();

                let termDate = new Date(Math.round((eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.disenrollDateIndex)] - 25568)*86400*1000));

                //exclude terms, expense, and non mrx plans
                if (eligValuesIndexCollection.fnIndex > 0
                    && eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.fnIndex)].toString().toUpperCase() !== "EXPENSE") {

                    if (eligValuesIndexCollection.groupIndex > 0) {
                        memberString += eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.groupIndex)].toString().padEnd(15, " ");
                    } else {
                        memberString += " ".repeat(15);
                    }

                    if (eligValuesIndexCollection.altIDIndex > 0) {
                        if (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.altIDIndex)].toString().length > 1) {
                            memberString += eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.altIDIndex)].toString().padEnd(20, " ");
                        } else {
                            memberString += (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberIndex)].toString().padStart(9, "0") + "01").padEnd(20, " ");
                        }

                    } else {
                        memberString += " ".repeat(20);
                    }

                    if (eligValuesIndexCollection.subscriberSSNIndex > 0) {
                        memberString += eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString().padStart(9, "0");
                    } else {
                        memberString += " ".repeat(9);
                    }

                    if (eligValuesIndexCollection.memberSegIndex > 0) {
                        memberString += eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.memberSegIndex)].toString().padStart(3, "0");
                    } else {
                        memberString += " ".repeat(3);
                    }

                    if (eligValuesIndexCollection.memberSegIndex > 0) {
                        if (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.memberSegIndex)].toString() === "01") {
                            memberString += "1";
                        } else if (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.memberSegIndex)].toString() === "02") {
                            memberString += "2";
                        } else {
                            memberString += "3";
                        }

                    } else {
                        memberString += " ".repeat(1);
                    }

                    if (eligValuesIndexCollection.sexIndex > 0) {
                        if (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.sexIndex)].toString().toUpperCase() === "MALE") {
                            memberString += "M";
                        } else if (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.sexIndex)].toString().toUpperCase() === "FEMALE") {
                            memberString += "F";
                        } else {
                            memberString += "U";
                        }
                    } else {
                        memberString += " ".repeat(1);
                    }

                    if (eligValuesIndexCollection.lnIndex > 0) {
                        memberString += eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.lnIndex)].toString().toUpperCase().padEnd(25, " ");
                    } else {
                        memberString += " ".repeat(25);
                    }

                    if (eligValuesIndexCollection.fnIndex > 0) {
                        memberString += eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.fnIndex)].toString().substring(0, 15).toUpperCase().padEnd(15, " ");
                    } else {
                        memberString += " ".repeat(15);
                    }

                    if (eligValuesIndexCollection.mnIndex > 0) {
                        memberString += eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.mnIndex)].toString().toUpperCase().substring(0, 1).padEnd(1, " ");
                    } else {
                        memberString += " ".repeat(1);
                    }

                    if (eligValuesIndexCollection.dobIndex > 0) {
                        let date = eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.dobIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.replace(/-/g, "");
                        }
                        memberString += date;
                    } else {
                        memberString += " ".repeat(8);
                    }

                    //for dependants get the stored sub address in next 5 fields
                    if (eligValuesIndexCollection.addIndex > 0 && eligValuesIndexCollection.memberSegIndex > 0 && eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.memberSegIndex)].toString() === "01") {
                        memberString += (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.addIndex)].toString().toUpperCase().padEnd(30, " ").substring(0, 30));
                    }
                    else if(eligValuesIndexCollection.subscriberSSNIndex > 0 && addressMap.has(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString())){
                        let address  = addressMap.get(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString());
                        if(address !== undefined){
                            memberString += address.toUpperCase().padEnd(30, " ").substring(0, 30);
                        }
                    }
                    else {
                        memberString += " ".repeat(30);
                    }

                    if (eligValuesIndexCollection.add2Index > 0 && eligValuesIndexCollection.memberSegIndex > 0 && eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.memberSegIndex)].toString() === "01") {
                        memberString += (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.add2Index)].toString().toUpperCase().padEnd(30, " "));
                    }
                    else if(eligValuesIndexCollection.subscriberSSNIndex > 0 && address2Map.has(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString())){
                        let address2  = address2Map.get(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString());
                        if(address2 !== undefined){
                            memberString += address2.toUpperCase().padEnd(30, " ");
                        }
                    }
                    else {
                        memberString += " ".repeat(30);
                    }

                    if (eligValuesIndexCollection.cityIndex > 0 && eligValuesIndexCollection.memberSegIndex > 0 && eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.memberSegIndex)].toString() === "01") {
                        memberString += (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.cityIndex)].toString().toUpperCase().padEnd(17, " ").substring(0, 17));
                    }
                    else if(eligValuesIndexCollection.subscriberSSNIndex > 0 && cityMap.has(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString())){
                        let city  = cityMap.get(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString());
                        if(city !== undefined){
                            memberString += city.toUpperCase().padEnd(17, " ").substring(0, 17);
                        }
                    }
                    else {
                        memberString += " ".repeat(17);
                    }

                    if (eligValuesIndexCollection.stateIndex > 0 && eligValuesIndexCollection.memberSegIndex > 0 && eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.memberSegIndex)].toString() === "01") {
                        let state: string = eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.stateIndex)].toString().toUpperCase();
                        if (state.length > 2 && GlobalConstants.statesWithAbbreviations.has(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.stateIndex)])) {
                            state = GlobalConstants.statesWithAbbreviations.get(state) ? state : "  ";
                        }
                        memberString += state.padEnd(2, " ");
                    }
                    else if(eligValuesIndexCollection.subscriberSSNIndex > 0 && stateMap.has(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString())){
                        let state  = stateMap.get(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString());
                        if(state !== undefined){
                            memberString += state.toUpperCase().padEnd(2, " ");
                        }
                    }
                    else {
                        memberString += "  ".repeat(1);
                    }

                    if (eligValuesIndexCollection.zipIndex > 0 && eligValuesIndexCollection.memberSegIndex > 0 && eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.memberSegIndex)].toString() === "01") {
                        memberString += (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.zipIndex)].toString().toUpperCase().padEnd(5, " ").substring(0, 5));
                    }
                    else if(eligValuesIndexCollection.subscriberSSNIndex > 0 && zipMap.has(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString())){
                        let zip  = zipMap.get(eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.subscriberSSNIndex)].toString());
                        if(zip !== undefined){
                            memberString += zip.toUpperCase().padEnd(5, " ").substring(0, 5);
                        }
                    }
                    else {
                        memberString += " ".repeat(5);
                    }

                    memberString += " ".repeat(4);

                    if (eligValuesIndexCollection.phoneIndex > 0) {
                        memberString += (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.phoneIndex)].toString().toUpperCase().padEnd(10, " "));
                    } else {
                        memberString += " ".repeat(10);
                    }

                    if (eligValuesIndexCollection.divisionIndex > 0) {
                        memberString += (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.divisionIndex)].toString().toUpperCase().padEnd(10, " "));
                    } else {
                        memberString += " ".repeat(10);
                    }

                    // if (eligValuesIndexCollection.planIDIndex > 0) {
                    //     memberString += (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.planIDIndex)].toString().toUpperCase().padEnd(10, " "));
                    // } else {
                    //     memberString += " ".repeat(10);
                    // }

                    memberString += " ".repeat(10);

                    if (eligValuesIndexCollection.enrollDateIndex > 0) {
                        let date = eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.enrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        memberString += date;
                    } else {
                        memberString += " ".repeat(8);
                    }

                    //fixed width requires yyyymmdd
                    if (eligValuesIndexCollection.disenrollDateIndex > 0) {
                        let date = eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.disenrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date === "117974" || date === "22221231") {
                            date = " ".repeat(8);
                        }
                        if (date.length > 6) {
                            let yearString = date.substring(0, 4);
                            let monthString = date.substring(4, 6);

                            if (monthString === "12"){
                                monthString = "01";

                                yearString = (Number(yearString) + 1).toString();

                                memberString += (yearString + monthString + "01").padEnd(24, " ");
                            }
                            else if (date !== "        "){
                                monthString = (Number(monthString) + 1).toString().padStart(2, "0");

                                memberString += (yearString + monthString + "01").padEnd(24, " ");
                            }
                            else {
                                memberString += " ".repeat(24);
                            }
                        }
                        else {
                            memberString += " ".repeat(24);
                        }

                    } else {
                        memberString += " ".repeat(24);
                    }

                    if (eligValuesIndexCollection.emailIndex > 0) {
                        memberString += (eligRawCellArray[(rowMultiplier + eligValuesIndexCollection.emailIndex)].toString().toUpperCase().padEnd(50, " "));
                    } else {
                        memberString += " ".repeat(50);
                    }

                    memberString += " ".repeat(22);

                    memberArray.push(memberString);

                    arrayOfMemberArrays.push(memberArray);
                }
            }

            //sorts by ID then member sequence
            arrayOfMemberArrays.sort((a, b) => (
                Number(a[0].substring(15,30).trim()) - Number(b[0].substring(15,30).trim()) || Number(a[0].substring(44,47)) - Number(b[0].substring(44,47)))
            );

            //create our workbook
            const eligWorkbook = utils.book_new();
            //make the member sheet from our member array of arrays
            let ws1 = utils.aoa_to_sheet(arrayOfMemberArrays, {dateNF: 'mm.dd.yyyy'});

            const today = new Date();

            const month = today.getMonth() + 1;

            let monthString = "";

            let dayString = "";

            if(month < 10){
                monthString = "0" + month.toString();
            }
            else{
                monthString = month.toString();
            }

            const day = today.getDate();

            if(day < 10) {
                dayString = "0" + day.toString();
            }
            else {
                dayString = day.toString();
            }

            const year = today.getFullYear();

            //add it to the new workbook
            utils.book_append_sheet(eligWorkbook, ws1, "CAS_FS_" + monthString + dayString + year);
            //it exists and has a sheet send it back to app for export
            if (eligWorkbook && eligWorkbook.SheetNames.includes("CAS_FS_" + monthString + dayString + year)) {
                if (!eligWorkbook.Props) eligWorkbook.Props = {};

                //setting the workbook title through props
                eligWorkbook.Props.Title = "CAS_FS_" + monthString + dayString + year + ".txt";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(eligWorkbook, "CAS_FS_" + monthString + dayString + year + ".txt", {});

                console.log("File Export Complete!");
                setSuccessAlert(true);
            } else {
                setErrorAlert(true);
                console.log("Unknown Export Error!");
            }

            //clear it out at the end in case of rerendering
            excelData.Sheets.FS = undefined;
        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.FS = undefined;
    }
    return (
        <div>
            {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                File Download Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
        </div>
    );
}


export default React.memo(FairscriptsFormatter)

FairscriptsFormatter.propTypes = {
    excelData: PropTypes.object.isRequired,
};